import { percent, ratio } from '../format.ts';

interface Props {
  label: string;
  used: number | null | undefined;
  total: number | null | undefined;
  /** how to render the numeric readout; defaults to used/total */
  render?: (used: number | null | undefined, total: number | null | undefined) => string;
  /** fraction above which the bar turns amber, then red */
  warnAt?: number;
  dangerAt?: number;
}

/**
 * A labelled utilisation bar. Colour changes at thresholds so a wall display
 * communicates without anyone reading the number.
 */
export function Meter({ label, used, total, render, warnAt = 0.8, dangerAt = 0.92 }: Props) {
  const fraction = ratio(used, total);
  const level = fraction === null ? '' : fraction >= dangerAt ? ' danger' : fraction >= warnAt ? ' warn' : '';
  const readout = render ? render(used, total) : `${percent(fraction)}`;

  return (
    <div className={`meter${level}`}>
      <div className="meter-head">
        <span className="label">{label}</span>
        <span className="value">{readout}</span>
      </div>
      <div className="track">
        <div className="fill" style={{ width: `${(fraction ?? 0) * 100}%` }} />
      </div>
    </div>
  );
}
